import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPhysicianDuties(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician-duty-imports', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianDutyImportItems(ctx, { id, ...data }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/physician-duty-imports/${id}/items`, { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianDutyImport(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/physician-duty-imports/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    uploadFile(ctx, { file, workplaceId, professionId }) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('workplace_id', workplaceId)
        formData.append('profession_id', professionId)
        axios
          .post('/physician-duty-imports', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchWorkplaces(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/workplaces/available-for-duty', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProfessions() {
      return new Promise((resolve, reject) => {
        axios
          .get('/institution/profession')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
